var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNodeSignalFast(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5569_40326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.5C4.5 13.9477 4.94772 13.5 5.5 13.5H6.5C7.05228 13.5 7.5 13.9477 7.5 14.5V18.5C7.5 19.0523 7.05228 19.5 6.5 19.5H5.5C4.94772 19.5 4.5 19.0523 4.5 18.5V14.5Z",
    fill: "#0EAB0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10C10.5 9.44772 10.9477 9 11.5 9H12.5C13.0523 9 13.5 9.44772 13.5 10V18.5C13.5 19.0523 13.0523 19.5 12.5 19.5H11.5C10.9477 19.5 10.5 19.0523 10.5 18.5V10Z",
    fill: "#0EAB0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.5C16.5 4.94772 16.9477 4.5 17.5 4.5H18.5C19.0523 4.5 19.5 4.94772 19.5 5.5V18.5C19.5 19.0523 19.0523 19.5 18.5 19.5H17.5C16.9477 19.5 16.5 19.0523 16.5 18.5V5.5Z",
    fill: "#0EAB0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5569_40326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeSignalFast);
export default __webpack_public_path__ + "static/media/node-signal-fast.3330d039d24b374a26b4f8e0a62493bc.svg";
export { ForwardRef as ReactComponent };